export default "__VITE_ASSET__84f18829__"